module.exports = __webpack_public_path__ + "static/media/ServCo Logo_1715288107144.1e3985ec.jpg";